<template>
   <div>
       <router-link :to="{ name: 'card_information', query: { vehicleId: this.$route.query.vehicleId, cardId: data.uniqueId, cardNumber: data.cardNumber }}" class="btn dealers_btn">{{$t('text.clickButtons.viewDetails')}}</router-link>
       <!-- <i class="fa-li fa fa-ellipsis-v dropbtn ml-2" @click="dropdownOption()"></i> -->
   </div>                             
</template>


<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
    data() {
        return {
        data: {},
        };
    },
    mounted() {
      
    },
    methods: {

    }
};
</script>